import React from 'react';
import './Clientes-Modal.css';
import Video from './assets/ElCarmen/Video.mp4';


const ElCarmen = () => {
    return (
        <div className='container'>
            <h2>✅Proyecto: Nuestra Señora del Carmen🌞✨</h2>
 <p>
     <video controls>
              <source src={Video} type="video/mp4" />
              Tu navegador no soporta la reproducción de video.
            </video>
    <span className="highlight">Energía solar al servicio de la comunidad: eficiencia, ahorro y compromiso con el cuidado del entorno. </span>

<br/><br/>En el proyecto Nuestra Señora del Carmen instalamos un sistema solar fotovoltaico conectado a la red con una capacidad de 6.3 kWp, conformado por 10 paneles solares de alta eficiencia y un inversor multicadena de 6 kW, una tecnología confiable que garantiza estabilidad energética y un óptimo aprovechamiento de la energía solar para las actividades del lugar.

<br/><br/>Gracias a esta solución, el sistema respalda de manera eficiente los consumos eléctricos de iluminación, equipos básicos y áreas de uso frecuente— reduciendo el consumo tomado de la red y optimizando los costos de operación.

<br/><br/>Los objetivos de este proyecto fueron:

<br/><br/>✔ Reducir los costos asociados al consumo eléctrico
<br/>✔ Implementar una solución sostenible alineada con el compromiso ambiental
<br/>✔ Garantizar energía constante y segura para las actividades diarias

<br/><br/>Hoy, Nuestra Señora del Carmen genera una parte importante de su energía limpia, logrando ahorros mensuales significativos y contribuyendo activamente a la reducción de la huella ambiental.

<br/><br/>Esta instalación convierte este espacio en un ejemplo de responsabilidad energética y uso consciente de los recursos naturales.

<br/><br/>Este proyecto cuenta con el acompañamiento de IPSUM Ingeniería e Innovación, ofreciendo:

<br/><br/>🔧 Soporte técnico y mantenimiento preventivo.
<br/>🔧 Monitoreo del sistema para garantizar máxima eficiencia energética.
<br/>🔧 Instalación estructural segura, diseñada para prolongar la vida útil del sistema y facilitar el mantenimiento.
<br/>🔧 Capacitación al usuario en el manejo de la aplicación de monitoreo.
<br/>🔧 Acompañamiento presencial de nuestros ingenieros durante y después de la instalación.

<br/><br/>Una decisión inteligente que une sostenibilidad, ahorro y compromiso con la comunidad.</p>

        </div>
    );
}

export default ElCarmen;
